export const translations = {
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      divisions: "Divisiones",
      sectors: "Sectores",
      projects: "Proyectos",
      contact: "Contacto",
      cta: "Hablar con un especialista",
    },
    hero: {
      overline: "ARIIVA — HOLDING DE TRANSFORMACIÓN",
      title: "Soluciones para un mundo en constante evolución",
      subtitle:
        "Integramos estrategia, infraestructura, energía, tecnología y desarrollo humano para transformar organizaciones de manera sostenible.",
      cta1: "Explorar Soluciones",
      cta2: "Hablar con un Especialista",
      tagline: "Estrategia · Infraestructura · Tecnología · Activos · Personas",
    },
    evol: {
      overline: "Quiénes somos",
      title: "Evolucionamos organizaciones.",
      p1: "ARIIVA es un holding multidisciplinario integrado por empresas especializadas en infraestructura, energía, tecnología, real estate, capital humano y consultoría estratégica.",
      p2: "Combinamos visión estratégica con capacidad de ejecución para generar resultados tangibles y sostenibles a escala internacional.",
    },
    approach: {
      overline: "Nuestro enfoque",
      title: "Cinco verbos. Una sola firma.",
      lead: "Desde la estrategia hasta la operación. Pensamos a largo plazo y ejecutamos con precisión.",
      items: [
        { tag: "01", verb: "Asesoramos", desc: "Convertimos desafíos en estrategias." },
        { tag: "02", verb: "Diseñamos", desc: "Transformamos ideas en soluciones viables." },
        { tag: "03", verb: "Construimos", desc: "Ejecutamos proyectos de alto impacto." },
        { tag: "04", verb: "Operamos", desc: "Maximizamos el desempeño de los activos." },
        { tag: "05", verb: "Evolucionamos", desc: "Impulsamos la mejora continua y el crecimiento sostenible." },
      ],
    },
    divisions: {
      overline: "Divisiones del holding",
      title: "Siete divisiones. Un solo ecosistema.",
      lead: "Cada empresa de ARIIVA Holding opera con foco propio y se integra con las demás para entregar soluciones completas a la industria, el sector inmobiliario y los corporativos.",
      list: [
        {
          code: "01",
          tag: "ARIIVA INFRA",
          title: "Energía, Agua e Infraestructura Industrial",
          lead: "Energía limpia y soluciones industriales sostenibles para la nueva economía.",
          services: [
            "BESS — Almacenamiento con Baterías",
            "Storage as a Service",
            "Microredes",
            "Energy as a Service",
            "Energía Solar Fotovoltaica",
            "Eficiencia Energética",
            "Tratamiento Integral de Agua",
            "Infraestructura Hidráulica",
          ],
          image:
            "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "02",
          tag: "ARIIVA ASSETS",
          title: "Facility Services y Operación de Activos",
          lead: "Operación recurrente y servicios integrales que aseguran la continuidad de tus inmuebles.",
          services: [
            "Mantenimiento de Edificios",
            "Seguridad Patrimonial",
            "Limpieza Industrial",
            "Comedores Industriales",
            "Jardinería",
            "Recepción",
            "Control de Accesos",
            "Hard Services",
            "Soft Services",
            "Operación Recurrente de Inmuebles",
          ],
          image:
            "https://images.pexels.com/photos/3862627/pexels-photo-3862627.jpeg?auto=compress&cs=tinysrgb&w=1600",
        },
        {
          code: "03",
          tag: "ARIIVA REAL ESTATE",
          title: "Activos Inmobiliarios Industriales",
          lead: "Naves, terrenos y parques industriales con visión de inversión y rentabilidad de largo plazo.",
          services: [
            "Venta y Renta de Naves Industriales",
            "Terrenos Industriales",
            "Parques Industriales",
            "Build to Suit",
            "Sale & Leaseback",
            "Comercialización Inmobiliaria",
            "Desarrollo Inmobiliario",
            "Asset Management Inmobiliario",
          ],
          image:
            "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "04",
          tag: "ARIIVA PROJECTS",
          title: "Diseño, Ingeniería y Construcción",
          lead: "De los planos a la obra terminada bajo un modelo llave en mano de alto estándar.",
          services: [
            "Arquitectura",
            "Ingeniería",
            "EPC",
            "Construcción Industrial",
            "Construcción Corporativa",
            "Remodelaciones",
            "Supervisión de Obra",
            "Project Management",
            "Cost Control",
            "Procurement Management",
            "Commissioning",
          ],
          image:
            "https://images.pexels.com/photos/2760344/pexels-photo-2760344.jpeg?auto=compress&cs=tinysrgb&w=1600",
        },
        {
          code: "05",
          tag: "ARIIVA DIGITAL",
          title: "Tecnología, IA y Transformación Digital",
          lead: "Convertimos datos en decisiones e instalaciones en activos inteligentes.",
          services: [
            "Inteligencia Artificial",
            "SaaS",
            "IoT Industrial",
            "Automatización",
            "Dashboards Ejecutivos",
            "Business Intelligence",
            "Smart Buildings",
            "Gemelos Digitales",
            "Monitoreo Remoto",
            "Desarrollo de Software",
          ],
          image:
            "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "06",
          tag: "ARIIVA HUMAN",
          title: "Capital Humano, Bienestar y Experiencias",
          lead: "Organizaciones más humanas, productivas y conectadas.",
          services: [
            "Reclutamiento",
            "Capacitación",
            "Coaching",
            "Wellness Corporativo",
            "Yoga",
            "Mindfulness",
            "Team Building",
            "Eventos Corporativos",
            "Catas de Cerveza Artesanal",
            "Experiencias Premium",
            "Viajes de Integración",
            "Cultura Organizacional",
          ],
          image:
            "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "07",
          tag: "ARIIVA ADVISORY",
          title: "Consultoría Estratégica y Servicios Especializados",
          lead: "Asesoría experta para decisiones críticas: ESG, legal, energía, riesgos y estrategia.",
          services: [
            "ESG",
            "Sustentabilidad",
            "Certificaciones ISO",
            "Asesoría Legal",
            "Seguros Todo Riesgo",
            "Consultoría Energética",
            "Due Diligence",
            "Estrategia Empresarial",
            "Desarrollo de Negocios",
            "Gestión de Alianzas",
            "Representaciones Comerciales",
          ],
          image:
            "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1600&q=80",
        },
      ],
    },
    sectors: {
      overline: "Sectores",
      title: "Donde estamos.",
      lead: "Atendemos industrias críticas con experiencia técnica, conocimiento normativo y capacidad operativa global.",
      list: [
        "Manufactura",
        "Energía",
        "Minería",
        "Oil & Gas",
        "Química",
        "Petroquímica",
        "Farmacéutica",
        "Centros de Datos",
        "Hospitalidad",
        "Corporativos",
        "Infraestructura",
        "Gobierno",
      ],
    },
    philosophy: {
      overline: "Filosofía",
      title: "Cuatro principios. Una sola dirección.",
      items: [
        { title: "Innovación", desc: "Buscamos constantemente nuevas formas de crear valor." },
        { title: "Sostenibilidad", desc: "Diseñamos pensando en las generaciones futuras." },
        { title: "Eficiencia", desc: "Optimizamos recursos, procesos y activos." },
        { title: "Evolución", desc: "Impulsamos la transformación continua." },
      ],
    },
    impact: {
      overline: "Impacto",
      title: "Cifras que construyen futuro.",
      stats: [
        { value: "+250", label: "Proyectos Ejecutados" },
        { value: "−42k t", label: "Emisiones Evitadas (CO₂e)" },
        { value: "+1.2 M m²", label: "Activos Administrados" },
        { value: "+120", label: "Clientes Atendidos" },
      ],
    },
    cta: {
      title: "Construyamos el futuro juntos.",
      lead: "Conversemos sobre cómo ARIIVA puede ayudarte a transformar tus proyectos, activos y operaciones.",
      button: "Hablemos de tu proyecto",
    },
    contact: {
      overline: "Contacto",
      title: "Iniciemos una conversación.",
      description:
        "Compártenos tu proyecto y nuestro equipo te contactará para diseñar una solución integral a tu medida.",
      form: {
        name: "Nombre completo",
        company: "Empresa",
        email: "Correo corporativo",
        interest: "División de interés",
        message: "Cuéntanos sobre tu proyecto",
        submit: "Enviar correo",
        privacy: "Al enviar aceptas nuestro aviso de privacidad.",
      },
      channels: {
        emailLabel: "Email",
        addressLabel: "Oficinas",
        address: "Ciudad de México, México",
      },
    },
    footer: {
      tagline: "Soluciones para un mundo en constante evolución.",
      rights: "Todos los derechos reservados.",
      privacy: "Aviso de Privacidad",
      sections: {
        company: "Compañía",
        divisions: "Divisiones",
        contact: "Contacto",
      },
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      divisions: "Divisions",
      sectors: "Sectors",
      projects: "Projects",
      contact: "Contact",
      cta: "Talk to a specialist",
    },
    hero: {
      overline: "ARIIVA — TRANSFORMATION HOLDING",
      title: "Solutions for a world in constant evolution",
      subtitle:
        "We integrate strategy, infrastructure, energy, technology and human development to transform organizations sustainably.",
      cta1: "Explore Solutions",
      cta2: "Talk to a Specialist",
      tagline: "Strategy · Infrastructure · Technology · Assets · People",
    },
    evol: {
      overline: "About us",
      title: "We evolve organizations.",
      p1: "ARIIVA is a multidisciplinary holding made up of specialized companies in infrastructure, energy, technology, real estate, human capital and strategic consulting.",
      p2: "We combine strategic vision with execution capability to deliver tangible, sustainable results at international scale.",
    },
    approach: {
      overline: "Our approach",
      title: "Five verbs. One firm.",
      lead: "From strategy to operations. We think long-term and execute with precision.",
      items: [
        { tag: "01", verb: "Advise", desc: "We turn challenges into strategies." },
        { tag: "02", verb: "Design", desc: "We transform ideas into viable solutions." },
        { tag: "03", verb: "Build", desc: "We deliver high-impact projects." },
        { tag: "04", verb: "Operate", desc: "We maximize asset performance." },
        { tag: "05", verb: "Evolve", desc: "We drive continuous improvement and sustainable growth." },
      ],
    },
    divisions: {
      overline: "Holding divisions",
      title: "Seven divisions. One ecosystem.",
      lead: "Each ARIIVA Holding company operates with its own focus and integrates with the others to deliver end-to-end solutions for industry, real estate and corporates.",
      list: [
        {
          code: "01",
          tag: "ARIIVA INFRA",
          title: "Energy, Water & Industrial Infrastructure",
          lead: "Clean energy and sustainable industrial solutions for the new economy.",
          services: [
            "BESS — Battery Storage",
            "Storage as a Service",
            "Microgrids",
            "Energy as a Service",
            "Solar Photovoltaic",
            "Energy Efficiency",
            "Integral Water Treatment",
            "Hydraulic Infrastructure",
          ],
          image:
            "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "02",
          tag: "ARIIVA ASSETS",
          title: "Facility Services & Asset Operations",
          lead: "Recurring operations and integral services that ensure the continuity of your properties.",
          services: [
            "Building Maintenance",
            "Asset Security",
            "Industrial Cleaning",
            "Industrial Canteens",
            "Gardening",
            "Reception",
            "Access Control",
            "Hard Services",
            "Soft Services",
            "Recurring Property Operations",
          ],
          image:
            "https://images.pexels.com/photos/3862627/pexels-photo-3862627.jpeg?auto=compress&cs=tinysrgb&w=1600",
        },
        {
          code: "03",
          tag: "ARIIVA REAL ESTATE",
          title: "Industrial Real Estate",
          lead: "Industrial warehouses, land and parks with long-term investment and profitability vision.",
          services: [
            "Industrial Warehouse Sale & Lease",
            "Industrial Land",
            "Industrial Parks",
            "Build to Suit",
            "Sale & Leaseback",
            "Real Estate Brokerage",
            "Real Estate Development",
            "Real Estate Asset Management",
          ],
          image:
            "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "04",
          tag: "ARIIVA PROJECTS",
          title: "Design, Engineering & Construction",
          lead: "From blueprints to commissioned assets under a high-standard turnkey model.",
          services: [
            "Architecture",
            "Engineering",
            "EPC",
            "Industrial Construction",
            "Corporate Construction",
            "Retrofits",
            "Site Supervision",
            "Project Management",
            "Cost Control",
            "Procurement Management",
            "Commissioning",
          ],
          image:
            "https://images.pexels.com/photos/2760344/pexels-photo-2760344.jpeg?auto=compress&cs=tinysrgb&w=1600",
        },
        {
          code: "05",
          tag: "ARIIVA DIGITAL",
          title: "Technology, AI & Digital Transformation",
          lead: "We turn data into decisions and facilities into intelligent assets.",
          services: [
            "Artificial Intelligence",
            "SaaS",
            "Industrial IoT",
            "Automation",
            "Executive Dashboards",
            "Business Intelligence",
            "Smart Buildings",
            "Digital Twins",
            "Remote Monitoring",
            "Software Development",
          ],
          image:
            "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "06",
          tag: "ARIIVA HUMAN",
          title: "Human Capital, Wellness & Experiences",
          lead: "More human, productive and connected organizations.",
          services: [
            "Recruiting",
            "Training",
            "Coaching",
            "Corporate Wellness",
            "Yoga",
            "Mindfulness",
            "Team Building",
            "Corporate Events",
            "Craft Beer Tastings",
            "Premium Experiences",
            "Integration Trips",
            "Organizational Culture",
          ],
          image:
            "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1600&q=80",
        },
        {
          code: "07",
          tag: "ARIIVA ADVISORY",
          title: "Strategic Consulting & Specialized Services",
          lead: "Expert advisory for critical decisions: ESG, legal, energy, risk and strategy.",
          services: [
            "ESG",
            "Sustainability",
            "ISO Certifications",
            "Legal Advisory",
            "All-Risk Insurance",
            "Energy Consulting",
            "Due Diligence",
            "Business Strategy",
            "Business Development",
            "Alliance Management",
            "Commercial Representation",
          ],
          image:
            "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1600&q=80",
        },
      ],
    },
    sectors: {
      overline: "Sectors",
      title: "Where we operate.",
      lead: "We serve critical industries with technical experience, regulatory knowledge and global operational capability.",
      list: ["Manufacturing","Energy","Mining","Oil & Gas","Chemical","Petrochemical","Pharmaceutical","Data Centers","Hospitality","Corporate","Infrastructure","Government"],
    },
    philosophy: {
      overline: "Philosophy",
      title: "Four principles. One direction.",
      items: [
        { title: "Innovation", desc: "We constantly seek new ways to create value." },
        { title: "Sustainability", desc: "We design with future generations in mind." },
        { title: "Efficiency", desc: "We optimize resources, processes and assets." },
        { title: "Evolution", desc: "We drive continuous transformation." },
      ],
    },
    impact: {
      overline: "Impact",
      title: "Numbers that build the future.",
      stats: [
        { value: "+250", label: "Projects Delivered" },
        { value: "−42k t", label: "Emissions Avoided (CO₂e)" },
        { value: "+1.2 M m²", label: "Assets Administered" },
        { value: "+120", label: "Clients Served" },
      ],
    },
    cta: {
      title: "Let's build the future together.",
      lead: "Let's talk about how ARIIVA can help you transform your projects, assets and operations.",
      button: "Let's talk about your project",
    },
    contact: {
      overline: "Contact",
      title: "Let's start a conversation.",
      description: "Share your project with us and our team will reach out to design an integral solution tailored to your needs.",
      form: {
        name: "Full name",
        company: "Company",
        email: "Corporate email",
        interest: "Division of interest",
        message: "Tell us about your project",
        submit: "Send email",
        privacy: "By submitting you accept our privacy notice.",
      },
      channels: {
        emailLabel: "Email",
        addressLabel: "Offices",
        address: "Mexico City, Mexico",
      },
    },
    footer: {
      tagline: "Solutions for a world in constant evolution.",
      rights: "All rights reserved.",
      privacy: "Privacy Notice",
      sections: {
        company: "Company",
        divisions: "Divisions",
        contact: "Contact",
      },
    },
  },
};

export const CONTACT_INFO = {
  email: "contacto@ari-iva.com",
  linkedin: "https://www.linkedin.com/company/67324225",
  instagram: "https://www.instagram.com/ariiva",
};

export const LOGO_SRC = "/ariiva-logo.png";
